import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';

import {PopoverModule} from 'ngx-popover';

import {CollapseMenuComponent} from './collapse-menu/collapse-menu.component';
import {RecentProjectsComponent} from './recent-projects/recent-projects.component';
import {FullScreenComponent} from './full-screen/full-screen.component';

import {ActivitiesComponent} from './activities/activities.component';
import {ActivitiesMessageComponent} from './activities/activities-message/activities-message.component';
import {ActivitiesNotificationComponent} from './activities/activities-notification/activities-notification.component';
import {ActivitiesTaskComponent} from './activities/activities-task/activities-task.component';
import {HeaderComponent} from './header.component';

import {UtilsModule} from '../../utils/utils.module';
import {I18nModule} from '../../i18n/i18n.module';
import {UserModule} from '../../user/user.module';
import {VoiceControlModule} from '../../voice-control/voice-control.module';
import {BsDropdownModule, ModalModule} from 'ngx-bootstrap';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SmartadminModule } from 'app/shared/smartadmin.module';
import { DialogModule } from 'primeng/primeng';
import { UserManualComponent } from './user-manual/user-manual.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
  imports: [
    CommonModule,
    //SmartadminModule,
    DialogModule,
    FormsModule,
    ModalModule,
    VoiceControlModule, 
    BsDropdownModule,
    PdfViewerModule,
    UtilsModule, I18nModule, UserModule, PopoverModule,
  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    FullScreenComponent,
    CollapseMenuComponent,
    ChangePasswordComponent,
    UserManualComponent,
    ActivitiesComponent,
    HeaderComponent,
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule{}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.module.ts